
























import axios from 'axios'
import { concat, eq, filter, first, forEach, indexOf, shuffle } from 'lodash'
import { Component, Ref, Vue } from 'vue-property-decorator'

import crossCheckEntity from '../assets/entities/cross-check.json'
import CrossCheckStage from './CrossCheckStage.vue'
import { numberWithCommas } from '@/helpers'

// const DEBUG_MODE = true
const LIMIT_TIME_IN_SECOND = 3
const SCORE_PER_SECOND = 0
const SCORE_PER_CORRECT = 10

@Component({
  components: {
    CrossCheckStage,
  },
})
export default class CrossCheck extends Vue {
  elapsedTime = 0
  allowedTime = LIMIT_TIME_IN_SECOND * 60 // 제한시간 3분

  stages: Array<ICrossCheckStage> = []
  currentStage: ICrossCheckStage | null = null
  scores = 0
  timer = 0

  @Ref('crossCheck') readonly elCrossCheck!: HTMLButtonElement

  created() {
    this.initStages()
  }

  mounted() {
    this.timer = setInterval(() => {
      this.elapsedTime += 1
      if (this.elapsedTime > this.allowedTime) {
        this.timeout()
      }
    }, 1000)
  }

  destroyed() {
    clearInterval(this.timer)
  }

  initGame() {
    this.elapsedTime = 0
    this.allowedTime = LIMIT_TIME_IN_SECOND * 60
  }

  initStages() {
    this.initGame()

    this.stages = (shuffle(
      crossCheckEntity.stages,
    ) as unknown) as ICrossCheckStage[]

    this.currentStage = first(this.stages) as ICrossCheckStage
  }

  timeout() {
    this.changeStage()
  }

  async gameWasCleared() {
    this.stages = []
    this.currentStage = null
    this.elapsedTime = 0
    this.allowedTime = 0
    clearInterval(this.timer)

    const profile = await this.$swal({
      title: '게임종료!',
      text: `당신의 점수는 ${this.scoresWithComma}점 입니다.`,
      input: 'text',
      inputLabel: '순위에 남길 이름을 입력해주세요.',
      inputValue: '',
      inputPlaceholder: '예) 토박이',
      confirmButtonText: '기록하기',
      showCancelButton: true,
      cancelButtonText: '취소하기',
      inputValidator: (inputValue: string) => {
        if (!inputValue) {
          return '이름을 입력해주세요.'
        }
        return null
      },
    })

    axios
      .post('/game/scores.php', {
        name: profile.value,
        type: 'cross-check',
        score: this.scores,
      })
      .then(data => data.data)
      .catch(e => console.error(e))

    this.$emit('onGameExit', {
      reason: 'clear-exit',
    } as GameExit)
  }

  calculateScore(correctScore: number) {
    this.scores += correctScore + this.timerCountDown * SCORE_PER_SECOND
  }

  changeStage() {
    this.initGame()

    const currentStageIndex = indexOf(this.stages, this.currentStage)
    this.currentStage = this.stages[currentStageIndex + 1] as ICrossCheckStage

    if (!this.currentStage) {
      this.gameWasCleared()
      return
    } else {
      this.$nextTick(() => {
        this.elCrossCheck.scrollTop = 0 // issue with scroll.
      })
    }
  }

  isEqualStage(value: ICrossCheckStage, other: ICrossCheckStage): boolean {
    return eq(value, other)
  }

  submit() {
    const answers = concat(
      this.currentStage?.x,
      this.currentStage?.y,
    ) as ICrossCheckAnswer[]

    forEach(answers, (answer: ICrossCheckAnswer) => {
      answer.userAnswer = answer.userAnswer || ''
      answer.correct = eq(answer.userAnswer, answer.answer)
    })

    /*
    const fails = filter(
      answers,
      (answer: ICrossCheckAnswer) => !answer.correct,
    )
    if (!DEBUG_MODE && fails.length > 0) {
      this.$swal({
        title: '땡!',
        text: `오답이 ${fails.length}개 있어요.`,
        icon: 'error',
      })
      return
    }
    */
    const correctScore =
      SCORE_PER_CORRECT *
      filter(answers, (answer: ICrossCheckAnswer) => answer.correct).length

    this.$swal({
      icon: 'success',
      title: '내기완료!',
      text: `다음 문제로 넘어갑니다.`,
      confirmButtonText: '확인',
    })

    this.calculateScore(correctScore)
    this.changeStage()
  }

  async confirmExit() {
    const confirm = await this.$swal({
      title: '그만하시겠습니까?',
      text: '그만두면 기록이 남지 않습니다.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '그만두기',
      cancelButtonText: '계속하기',
    })

    if (confirm.isConfirmed) {
      this.$emit('onGameExit', {
        reason: 'self-exit',
      } as GameExit)
    }
  }

  get timerCountDown() {
    return this.allowedTime - this.elapsedTime
  }

  get scoresWithComma() {
    return numberWithCommas(this.scores)
  }
}
